import PropTypes from 'prop-types';
import * as React from 'react';
import FormattedMessage from './FormattedMessage';
import I18n from 'I18n';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultElements = {
  wrapper: 'span'
};
function createElement(elements, type, ...args) {
  return /*#__PURE__*/React.createElement(
  // @ts-expect-error Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
  elements && elements[type] ||
  // @ts-expect-error dynamic key access
  defaultElements[type] || defaultElements.wrapper,
  // @ts-expect-error spread args for React.createElement
  ...args);
}
function renderMissingOrInvalidKey(props) {
  console.warn(`I18n: FormattedJSXMessage called with missing or non-JSX message key ${props.message}. See go/i18n-react for more info.`);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: props.message,
    options: props.options
  });
}
const isSet = value => {
  return value !== undefined && value !== null;
};
const FormattedJSXMessage = props => {
  var _props$options;
  React.useContext(I18nHMRContext);
  // @ts-expect-error I18n.lookup is not in the type declarations
  let fn = I18n.lookup(props.message, {
    // @ts-expect-error I18n.langEnabled/locale are not in the type declarations
    locale: (props === null || props === void 0 || (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.locale) || (I18n.langEnabled ? I18n.locale : 'en')
  });
  if (!isSet(fn)) {
    return renderMissingOrInvalidKey(props);
  }

  // @ts-expect-error Property 'count' does not exist on type 'object'.
  const count = props.options && props.options.count;
  const countIsSet = isSet(count);
  if (typeof fn === 'object' && countIsSet) {
    // @ts-expect-error I18n.pluralization is not in the type declarations
    const pluralizer = I18n.pluralization.get();
    const keys = pluralizer(count);
    while (keys.length) {
      const key = keys.shift();
      // @ts-expect-error fn is dynamically typed
      if (isSet(fn[key])) {
        // @ts-expect-error fn is dynamically typed
        fn = fn[key];
        break;
      }
    }
  }
  const formattedProps = Object.assign({}, props.options);
  if (countIsSet && typeof count === 'number') {
    // @ts-expect-error Property 'count' does not exist on type '{}'
    formattedProps.count = I18n.formatNumber(count);
  } else if (typeof fn === 'string') {
    return renderMissingOrInvalidKey(props);
  }
  return fn(createElement, props.elements, formattedProps);
};
FormattedJSXMessage.propTypes = {
  message: PropTypes.string.isRequired,
  elements: PropTypes.object.isRequired,
  options: PropTypes.object,
  jsxMessageValidator: (props, _propName, componentName) => {
    if (typeof props.message === 'string' && !props.message.endsWith('_jsx')) {
      console.warn(`I18n: ${componentName} called with invalid message prop not ending in _jsx for ${props.message}`);
    }
    return null;
  }
};
export default FormattedJSXMessage;